import { AddFieldValuesUseCase } from 'shared/domain/fieldValue/addFieldValues';
import { EditableFieldValuesEntityName } from 'shared/domain/fieldValue/fields';
import { CreateFieldValueModel } from 'shared/domain/fieldValue/fieldValueModel';
import {
  fieldValuesRequestRunner,
  IFieldValuesRequestRunner,
} from './fieldValuesRequestRunner';
import { syncFieldValuesAfterMutation } from './fieldValueSources';

class FieldValuesCreator implements AddFieldValuesUseCase {
  constructor(private requestRunner: IFieldValuesRequestRunner) {}

  async execute(
    fieldName: EditableFieldValuesEntityName,
    fieldValues: CreateFieldValueModel[]
  ): Promise<void> {
    // Synced also after a partial failure: the requests that succeeded must show.
    try {
      await this.requestRunner.execute({
        fieldName,
        fieldValues,
      });
    } finally {
      syncFieldValuesAfterMutation(fieldName);
    }
  }
}

export const fieldValuesCreator = new FieldValuesCreator(fieldValuesRequestRunner);
